import { Grid } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { helpText } from '../../sic-lib/types/infoData';

interface Props {
    isOpen: boolean;
    onConfirmHandler: () => void;
}

export default function DialogFilterDescription({ isOpen, onConfirmHandler }: Props) {
    const { classes } = useStyles();

    const handleConfirm = () => {
        onConfirmHandler();
    };

    const handleCancel = (event: React.MouseEvent<HTMLButtonElement>, reason?: string) => {
        if (!reason || (reason !== 'backdropClick' && reason !== 'escapeKeyDown')) {
            onConfirmHandler();
        }
    };

    return (
        <Dialog
            open={isOpen}
            onClose={handleCancel}
            maxWidth="xs"
            aria-labelledby="dialog_filter_description"
        >
            <DialogTitle id="dialog_filter_description">Filter Helper</DialogTitle>
            <DialogContent dividers>
                <Typography
                    className={classes.txtTitle}
                    align="center"
                    component="p"
                    variant="body1"
                    gutterBottom
                >
                    Date Range
                </Typography>
                {helpText['Date Range'].map(itm => (
                    <Grid key={`diaFilDes_${itm.title}`}>
                        <Typography component="p" variant="subtitle2">
                            {itm.title}
                        </Typography>
                        <Typography component="p" variant="caption" gutterBottom>
                            {itm.paragraph}
                        </Typography>
                    </Grid>
                ))}
                <Typography
                    className={classes.txtTitle}
                    align="center"
                    component="p"
                    variant="body1"
                    gutterBottom
                >
                    Channel
                </Typography>
                {helpText['Channel'].map(itm => (
                    <Grid key={`diaChan_${itm.title}`}>
                        <Typography component="p" variant="subtitle2">
                            {itm.title}
                        </Typography>
                        <Typography component="p" variant="caption" gutterBottom>
                            {itm.paragraph}
                        </Typography>
                    </Grid>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleConfirm} color="secondary" variant="outlined">
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    btnCancel: {
        marginRight: theme.spacing(1),
        color: theme.palette.btnDefault.main,
        '&:hover': {
            backgroundColor: theme.palette.btnDefault.light,
        },
    },
    txtTitle: {
        fontWeight: 'bold',
    },
}));
